/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { licensesActivate } from "../../funcs/licensesActivate.js";
import * as components from "../../models/components/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: components.ActivateLicenseRequestEntity$inboundSchema,
};

export const tool$licensesActivate: ToolDefinition<typeof args> = {
  name: "licenses-activate",
  description: `Activates a license key.

Activate a license key for a specific device or instance. Register new activations and track usage limits.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await licensesActivate(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
